import { useBorrowerIsDelinquentOnTaxes } from '../../../../../../../queries/BorrowerFields/LegalityFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface DelinquentOnTaxesProps {
    required?: boolean;
    isReview?: boolean;
}

export const DelinquentOnTaxes: React.FC<DelinquentOnTaxesProps> = ({ required = false, isReview = false }) => {
    const label = 'Delinquent on any taxes?';
    const [delinquentOnTaxes, set_delinquentOnTaxes] = useBorrowerIsDelinquentOnTaxes();

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_delinquentOnTaxes(true);
                return;
            case 'no':
                set_delinquentOnTaxes(false);
                return;
            default:
                return;
        }
    };

    const parseDisplayValue = (value: boolean | undefined) => {
        if (value) {
            if (value == true || value == 'true') {
                return 'Yes';
            } else if (value == false || value == 'false') {
                return 'No';
            }
        }
        return '';
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={parseDisplayValue(delinquentOnTaxes)}
                />
            ) : (
                <YesNoToggleButton
                    id='delinquentOnTaxes'
                    value={delinquentOnTaxes}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Delinquent on taxes required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
